module.exports = __webpack_public_path__ + "logo.f87e7a4f.jpg";